import FeatureSimpleForm from './FeatureSimpleForm'

export default FeatureSimpleForm
